export default __webpack_public_path__ + "static/team-img4-1017be561da9c77b3b9c64bfbfa0348e.jpg";